import fetch from "./fetch"
import release from "./release"
import processing from "./processing"

const INITIAL_STATE = {
  involved: 0,
  process: null,
  data: [],
}

export default function entityReducer(state = false, action) {
  let nextState = state || {
    ...INITIAL_STATE,
    engine: action.engine,
    model: action.model,
    query: action.query,
  }
  nextState = fetch(nextState, action)
  nextState = processing(nextState, action)
  return release(nextState, action)
}
